import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Divider } from "@mui/material";

export interface PendingChangesCategory {
  label: string;
  count: number;
  items?: string[];
}

interface PendingChangesSummaryModalProps {
  open: boolean;
  onClose: () => void;
  total: number;
  categories: PendingChangesCategory[];
}

const PendingChangesSummaryModal: React.FC<PendingChangesSummaryModalProps> = ({ open, onClose, total, categories }) => {
  const changed = categories.filter((category) => category.count > 0);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Pending Changes ({total})
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
          Everything not yet saved to the draft. Each tab shows only its own changes, so these numbers add up to the total in the
          header.
        </Typography>
        {changed.map((category, index) => (
          <Box key={category.label} sx={{ mb: 1.5 }}>
            {index > 0 && <Divider sx={{ mb: 1.5 }} />}
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="body1">
                <strong>{category.label}</strong>
              </Typography>
              <Typography variant="body1">
                <strong>{category.count}</strong>
              </Typography>
            </Box>
            {category.items?.map((item, itemIndex) => (
              <Typography key={`${category.label}-${itemIndex}`} variant="body2" sx={{ pl: 2, opacity: 0.75 }}>
                {item}
              </Typography>
            ))}
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PendingChangesSummaryModal;
